import {
    FILTRO_CONSULTACOMPRASPRODUCTO,
    LISTAR_CONSULTACOMPRASPRODUCTO,
} from '../../types'


export default (state, action) => {
    switch (action.type){
        case FILTRO_CONSULTACOMPRASPRODUCTO: 
            return{
                ...state, 
                filtrosConsultaComprasProducto: action.payload
            }
        case LISTAR_CONSULTACOMPRASPRODUCTO:
            return{
                ...state,
                consultaComprasProductoFiltradas: action.payload
            }
        default:
            return state
    }
        
}